import NonDismissibleModal from '@bufferapp/ui/NonDismissibleModal'

import { getActiveProductFromPath } from '../../../../common/utils/getProduct'
import { EngagementContent } from './components/EngagementContent'
import { AnalyticsContent } from './components/AnalyticsContent'
import { useSplit } from '@buffer-mono/features'

export const Paywall = (): JSX.Element | null => {
  let product = getActiveProductFromPath()

  const { split, isReady: isAnalyzeInAppPaywallReady } = useSplit(
    'analyze-in-app-paywall',
  )
  const isAnalyzeInAppPaywallEnabled = split.treatment === 'on'

  // for local development
  if (product === 'appshell') {
    product = 'engage'
  }

  if (product === 'engage') {
    return (
      <NonDismissibleModal>
        <EngagementContent />
      </NonDismissibleModal>
    )
  }

  if (product === 'analyze' && isAnalyzeInAppPaywallReady) {
    if (!isAnalyzeInAppPaywallEnabled) {
      return (
        <NonDismissibleModal>
          <AnalyticsContent />
        </NonDismissibleModal>
      )
    }
  }

  return null
}
